
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/alerts",
      function () {
        return require("private-next-pages/tools/alerts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/alerts"])
      });
    }
  